module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/wardrobe/wardrobe.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/wardrobe/wardrobe.png
// module id = 651
// module chunks = 0